import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
import bannerRetroDesk from "../../assets/images/pngs/bannerRetroDesk.png";
import bannerRetroMobile from "../../assets/images/pngs/bannerRetroMobile.png";
import bannerRetroDesk2 from "../../assets/images/pngs/bannerRetroDesk2.png";
import bannerRetroMobile2 from "../../assets/images/pngs/bannerRetroMobile2.png";
import bannerRetroDesk3 from "../../assets/images/pngs/bannerRetroDesk3.png";
import bannerRetroMobi31 from "../../assets/images/pngs/bannerRetroMobi31.png";
import bannerRetroMobi32 from "../../assets/images/pngs/bannerRetroMobi32.png";
import bannerRetroDesk4 from "../../assets/images/pngs/bannerRetroDesk4.png";
import bannerRetroMobile4 from "../../assets/images/pngs/bannerRetroMobile4.png";
import bannerRetroDesk5 from "../../assets/images/pngs/bannerRetroDesk5.png";
import bannerRetroMobile5 from "../../assets/images/pngs/bannerRetroMobile5.png";
import bgFooterDesk from "../../assets/images/pngs/bgFooterDesk.png";
import bgFooterMobile from "../../assets/images/pngs/bgFooterMobile.png";
import imagemCompartilhada from "../../assets/images/pngs/imagemCompartilhada.png";
import semListaParticipantesDesk from "../../assets/images/pngs/semListaParticipantesDesk.png";
import semListaParticipantesMobile from "../../assets/images/pngs/semListaParticipantesMobile.png";
import semRankingDesk from "../../assets/images/pngs/semRankingDesk.png";
import semRankingMobile from "../../assets/images/pngs/semRankingMobile.png";
import semGeralDesk from "../../assets/images/pngs/semGeralDesk.png";
import semGeralMobile from "../../assets/images/pngs/semGeralMobile.png";
import queridinhosDesk from "../../assets/images/pngs/queridinhosDesk.png";
import queridinhosMobile from "../../assets/images/pngs/queridinhosMobile.png";
import imagemCentral from "../../assets/images/pngs/imagemCentral.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper";
import BarraProgresso from "../../Components/BarraProgresso";
import ItensQueridos from "../../Components/ItensQueridos";
import storage from "../../services/storage";
import html2canvas from "html2canvas";

export default function Retrospectiva() {
  const { setLoad } = useLoad();
  const [largura, setLargura] = useState(window.innerWidth);

  const [listaParticipante, setListaParticipante] = useState([]);
  const [listaGeral, setListaGeral] = useState([]);
  const [listaRanking, setListaRanking] = useState({});
  const [imagem, setImagem] = useState("");
  useEffect(() => {
    const handleResize = () => {
      setLargura(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  async function fnRanking() {
    try {
      let response = await ApiServices.apiGet(
        `retrospectiva/credito?codi_cli=${
          storage.get("USUARIO").codiCli
        }&ano=2024`
      );

      setListaRanking(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnParticipante() {
    try {
      let response = await ApiServices.apiGet(
        `retrospectiva/participante?codi_cli=${
          storage.get("USUARIO").codiCli
        }&ano=2024`
      );
 
      setListaParticipante(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnGeral() {
    try {
      let response =
        await ApiServices.apiGet(`retrospectiva/participante-vitrine?codi_cli=${storage.get("USUARIO").codiCli}`);
      setListaGeral(response.data);
      setImagem(response.data[0]?.urlImagem); 
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnRanking();
    fnParticipante();
    fnGeral();
  }, []);

  const mergeRef = useRef(null);

  const handleDownload = async () => {
    if (mergeRef.current) {
      // Garantir que as imagens dentro do elemento estão prontas para renderização
      const imageElement = new Image();
      imageElement.crossOrigin = "anonymous"; // Permite lidar com imagens de domínio cruzado
      imageElement.src = listaGeral[0]?.urlImagem || "";

      imageElement.onload = async () => {
        try {
          // Renderizar o canvas após o carregamento da imagem
          const canvas = await html2canvas(mergeRef.current, { useCORS: true });
          const link = document.createElement("a");
          link.download = "merged-image.png";
          link.href = canvas.toDataURL("image/png");
          link.click();
        } catch (error) {
          console.error("Erro ao capturar a imagem com html2canvas:", error);
        }
      };

      imageElement.onerror = () => {
        console.error("Falha ao carregar a imagem.");
      };
    }
  };

  return (
    <div>
      <img
        className="desktop"
        width={"100%"}
        src={bannerRetroDesk}
        alt="Banner Retrospectiva"
      />
      <img
        style={{ paddingTop: "90px" }}
        className="mobile"
        width={"100%"}
        src={bannerRetroMobile}
        alt="Banner Retrospectiva"
      />
      <img
        className="desktop"
        width={"100%"}
        src={bannerRetroDesk2}
        alt="Banner Retrospectiva"
      />
      <img
        className="mobile"
        width={"100%"}
        src={bannerRetroMobile2}
        alt="Banner Retrospectiva"
      />
      <div className="p-4" style={{ marginTop: "-25%" }}>
        <img
          className="desktop"
          width={"100%"}
          src={bannerRetroDesk3}
          alt="Banner Retrospectiva"
        />
      </div>
      <div className="p-4 mobile" style={{ marginTop: "-25%" }}>
        <Swiper
          pagination={{
            clickable: true,
          }}
          spaceBetween={-5}
          loop={false}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide style={{ backgroundColor: "#00000000" }}>
            <img
              width={"100%"}
              src={bannerRetroMobi31}
              alt="Banner Retrospectiva"
            />
          </SwiperSlide>
          <SwiperSlide style={{ backgroundColor: "#00000000" }}>
            <img
              width={"100%"}
              src={bannerRetroMobi32}
              alt="Banner Retrospectiva"
            />
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="d-flex justify-content-center py-3">
        <img
          width={"50%"}
          className="desktop"
          src={bannerRetroDesk4}
          alt="Banner Retrospectiva"
        />
        <img
          width={"60%"}
          className="mobile"
          src={bannerRetroMobile4}
          alt="Banner Retrospectiva"
        />{" "}
      </div>

      {/* CARROCEL DE PRODUTOS */}
      {listaParticipante?.length > 0 ? (
        <div className="p-4">
          <Swiper
          centeredSlidesBounds={true}
            centerInsufficientSlides={true}
           centeredSlides={true}
            pagination={{
              clickable: true,
            }}
            slidesPerView={
              largura > 2000
                ? 5
                : largura > 1800
                ? 4
                : largura > 1500
                ? 3.5
                : largura > 1500
                ? 3
                : largura > 1130
                ? 2.5
                : largura > 770
                ? 1
                : 1
            }
            spaceBetween={10}
           
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            modules={[Autoplay, Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {listaParticipante.map((item, index) => (
              <SwiperSlide key={index} style={{ backgroundColor: "#00000000" }}>
                <div
                  className="d-flex flex-column align-items-center"
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e0e0e0",
                    padding: 20,
                    borderRadius: 40,
                    height: 430,
                  }}
                >
                  <div className="d-flex ">
                    <div style={{ width: 300, height: 300 }}>
                      <img
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "100%",
                        }}
                        src={item.urlImagem}
                      />
                    </div>
                  </div>
                  <div className=" tituloCardRetro">{item.nomeProduto}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="p-4">
          <img
            width={"100%"}
            className="desktop"
            src={semListaParticipantesDesk}
            alt="Banner Retrospectiva"
          />

          <img
            width={"100%"}
            className="mobile"
            src={semListaParticipantesMobile}
            alt="Banner Retrospectiva"
          />
        </div>
      )}

      {/* BARRA DE PROGRASSO */}
      {listaRanking?.length > 0 ? (
        <div className="position-relative">
          <img
            width={"100%"}
            className="desktop"
            src={bannerRetroDesk5}
            alt="Banner Retrospectiva"
          />

          <img
            width={"100%"}
            className="mobile"
            src={bannerRetroMobile5}
            alt="Banner Retrospectiva"
          />
          <div
            className="d-flex justify-content-center position-absolute w-100"
            style={{ top: "50%" }}
          >
            <div style={{ width: "90%" }}>
              <BarraProgresso listaRanking={listaRanking} />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <img
            width={"100%"}
            className="desktop"
            src={semRankingDesk}
            alt="Banner Retrospectiva"
          />

          <img
            width={"100%"}
            className="mobile"
            src={semRankingMobile}
            alt="Banner Retrospectiva"
          />
        </div>
      )}

      {/* TOP 5 PRODUTOS */}
      <div>
        <div className="d-flex justify-content-center pt-5">
          <img
            width={"50%"}
            className="desktop"
            src={queridinhosDesk}
            alt="Banner Retrospectiva"
          />

          <img
            width={"60%"}
            className="mobile"
            src={queridinhosMobile}
            alt="Banner Retrospectiva"
          />
        </div>

        <div className="bgItensQueridos">
          {listaGeral?.length > 0 ? (
            <ItensQueridos lista={listaGeral} />
          ) : (
            <div className="p-4 py-5">
              <img
                width={"100%"}
                className="desktop"
                src={semGeralDesk}
                alt="Banner Retrospectiva"
              />

              <img
                width={"100%"}
                className="mobile"
                src={semGeralMobile}
                alt="Banner Retrospectiva"
              />
            </div>
          )}
        </div>
      </div>

      <img
        width={"100%"}
        className="desktop"
        src={bgFooterDesk}
        alt="Banner Retrospectiva"
      />

      <img
        width={"100%"}
        className="mobile"
        src={bgFooterMobile}
        alt="Banner Retrospectiva"
      />

      <div
        className="d-flex justify-content-center"
        style={{ marginTop: -100, marginBottom: 60 }}
      >
        <button
          className="btn btn-warning btn-lg"
          style={{ maxWidth: 200 }}
          onClick={handleDownload}
        >
          Compartilhar
        </button>

        <div
          className="visually-hidden"
          style={{
            textAlign: "center",
            marginTop: "20px",
            width: "300px",
            height: "650px",
          }}
        >
          {/* Div que contém as imagens a serem unidas */}
          <div
            ref={mergeRef}
            style={{
              display: "inline-block",
              position: "relative",
              width: "300px",
              height: "650px",
            }}
          >
            <img
              src={imagemCompartilhada}
              alt="Imagem 1"
              width={"100%"}
              style={{ position: "absolute", top: 0, left: 0 }}
            />

            <img
              src={listaGeral[0]?.urlImagem || ""}
              alt="Imagem 2"
              width={"60%"}
              style={{
                position: "absolute",
                top: "60.72%",
                left: "50%",
                borderRadius: "100%",
                transform: "translate(-50%, -50%)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: 100,
                width: "250px",
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2, // Limita o texto a duas linhas
                lineHeight: "1.2em", // Define a altura de cada linha
                maxHeight: "2.4em", // Altura máxima para duas linhas
                padding: 10,
                wordBreak: "break-word",
              }}
            >
              {listaGeral[0]?.nomeProduto}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
